export const margins = {
  defaultPageMargin: 18
};
